import React from 'react';

const ConfirmationModal = ({
  open,
  title = "Bestätigung",
  message,
  type = "confirm", // "confirm", "alert"
  onConfirm,
  onCancel,
  confirmText = "OK",
  cancelText = "Abbrechen"
}) => {
  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      if (type === 'alert') {
        onConfirm();
      } else {
        onCancel();
      }
    }
  };

  const handleKeyDown = React.useCallback((e) => {
    if (!open) return;
    
    if (e.key === 'Escape') {
      if (type === 'alert') {
        onConfirm();
      } else {
        onCancel();
      }
    }
    if (e.key === 'Enter' && type === 'alert') {
      onConfirm();
    }
  }, [open, type, onConfirm, onCancel]);

  React.useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [handleKeyDown]);

  if (!open) return null;



  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(0,0,0,0.4)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 999999
      }}
      onClick={handleOverlayClick}
    >
      <div
        style={{
          background: '#fff',
          padding: 24,
          borderRadius: 8,
          minWidth: 300,
          maxWidth: 500,
          boxShadow: '0 4px 24px rgba(0,0,0,0.2)',
          display: 'flex',
          flexDirection: 'column',
          gap: 16,

        }}
        onClick={(e) => e.stopPropagation()}
      >
        <h3 style={{ margin: 0, color: '#333', fontSize: 18 }}>
          {title}
        </h3>
        
        <div style={{
          color: '#666',
          fontSize: 14,
          lineHeight: 1.4,
          whiteSpace: 'pre-wrap'
        }}>
          {message}
        </div>
        
        <div style={{
          display: 'flex',
          justifyContent: 'flex-end',
          gap: 8,
          marginTop: 8
        }}>
          {type === 'confirm' && (
            <button
              onClick={onCancel}
              style={{
                background: '#eee',
                color: '#333',
                border: 'none',
                borderRadius: 4,
                padding: '8px 16px',
                cursor: 'pointer',
                fontSize: 14,
                minWidth: 80
              }}
            >
              {cancelText}
            </button>
          )}
          
          <button
            onClick={onConfirm}
            autoFocus
            style={{
              background: type === 'confirm' ? '#d32f2f' : '#1976d2',
              color: '#fff',
              border: 'none',
              borderRadius: 4,
              padding: '8px 16px',
              cursor: 'pointer',
              fontSize: 14,
              minWidth: 80
            }}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;